import React, { useState, useEffect } from 'react';
import NoteService from "../../services/NoteService";
import AccordionT from "./Accordion/AccordionT";
import useIsMobile from "../../utils/useIsMobile";

function DrivingNotesComponent({  card, handleClick, statusValues, handleStatusChange, currentIndex, groupLength, goToPrevious, goToNext }) {
    const [imageData, setImageData] = useState([]);
    const isMobile = useIsMobile();
    const handleExpandClick = async (parameter) => {
        const { number } = card;
        try {
            const requests = Array.from({ length: 3 }, (_, index) =>
                NoteService.getDescription2(parameter, number.toString())
            );
            const responses = await Promise.all(requests);
            const imageDataArray = responses.map((response) => {
                const blob = new Blob([response.data]);
                return blob;
            });
            setImageData(imageDataArray);
        } catch (error) {
            console.error('Error fetching image:', error);
        }
    };
    const InfoA1 = "Tala högt om dina handlingar för din handledare om du känner dig bekväm med att köra och prata samtidigt. På så sätt kan din handledare följa dina tankar och ha koll på dina handlingar och eventuella misstag. Denna teknik är ett stort plus för din inlärningsprocess.";
    const InfoA5 = "I det här momentet, läs igenom hela instruktionen innan du påbörjar övningarna. Välj en lugn gata, ett industriområde, en stor parkering eller någon annan lämplig plats utan bilar, cyklar eller gångtrafikanter för dina övningar..";
    const InfoA6 = "Välj en lugn gata, ett industriområde, en landsväg eller någon annan lämplig plats utan bilar, cyklar eller gångtrafikanter för dina övningar.";
    const InfoA7 = "Välj en lugn gata, ett industriområde, en landsväg eller någon annan lämplig plats utan bilar, cyklar eller gångtrafikanter för dina övningar.";
    const InfoA15 = "Välj en trafikfri plats (till exempel ett villaområde) där det finns gott om utrymme mellan bilarna du ska parkera mellan. Detta för att undvika kollisioner med parkerade bilar.";
    const InfoA16 = "Tala högt om dina handlingar för din handledare om du känner dig bekväm med att köra och prata samtidigt. På så sätt kan din handledare följa dina tankar och ha koll på dina handlingar och eventuella misstag.";

    return (
        <>
            <h1 className='center pt-32' style={{ color: "#bebdbd", width: "100%", textAlign: "center" }}>GRUNDLÄGGANDE MOMENT</h1>
            {card.number === 8 && <h1 className='center pt-32' style={{ color: "#bebdbd", width: "100%", textAlign: "center" }}>INLEDANDE TRAFIK</h1>}
            {card.number === 10 && <h1 className='center pt-32' style={{ color: "#bebdbd", width: "100%", textAlign: "center" }}>STADSTRAFIK OCH LANDSVÄG</h1>}
            {card.number === 15 && <h1 className='center pt-32' style={{ color: "#bebdbd", width: "100%", textAlign: "center" }}>AVANCERADE MOMENT</h1>}

            <div className="center card item mb-32 pt-32 ">
                <div>
                Lektion {currentIndex + 1} av {groupLength}
                    <div className="pb-16 pt-16 icon-text">{card.nytitle}</div>

                </div>
                <button
                    className="ghostbutton"
                    style={{ maxWidth: 129 }}
                    onClick={goToPrevious}
                    disabled={currentIndex === 0}
                >◀ Föregående</button>

                <button
                    onClick={goToNext}
                    disabled={currentIndex === groupLength - 1}
                    className="ghostbutton"
                    style={{ maxWidth: 129 }}
                >Nästa ▶</button>

            </div>

            <div className={"center"} key={card.id}>

                {card.isDone &&<> <h2>🏁</h2><br />  <h3 className="pb-32">Klar!</h3></>}

                {card.number === 1 && InfoA1}
                {card.number === 5 && InfoA5}
                {card.number === 6 && InfoA6}
                {card.number === 7 && InfoA7}
                {card.number === 15 && InfoA15}
                {card.number === 16 && InfoA16}

                {card.catA && (
                    <>
                        <h3 className='p-16 pt-32'>{card.catA}</h3>
                        <AccordionT
                            title={<h3>Instruktioner</h3>}
                            parameter={`catA1`}
                            number={card.number.toString()}
                            onExpandClick={handleExpandClick}
                            imageData={imageData}
                        />
                        <select
                            className='center'
                            value={card.statA || ''}
                            onChange={(e) => handleStatusChange(e, card.id, 'statA')}
                        >
                            <option value="">----Välj----</option>
                            {statusValues.map((value) => (
                                <option key={value} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    </>
                )}
                {card.catB && (
                    <>
                        <h3 className='p-16 mt-64'>{card.catB}</h3>
                        <AccordionT
                            title={<h3>Instruktioner</h3>}
                            parameter={`catB1`}
                            number={card.number.toString()}
                            onExpandClick={handleExpandClick}
                            imageData={imageData}
                        />
                        <select
                            className='center'
                            value={card.statB || ''}
                            onChange={(e) => handleStatusChange(e, card.id, 'statB')}
                        >
                            <option value="">----Välj----</option>
                            {statusValues.map((value) => (
                                <option key={value} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    </>
                )}
                {card.catC && (
                    <>
                        <h3 className='p-16 mt-64'>{card.catC}</h3>
                        <AccordionT
                            title={<h3>Instruktioner</h3>}
                            parameter={`catC1`}
                            number={card.number.toString()}
                            onExpandClick={handleExpandClick}
                            imageData={imageData}
                        />
                        <select
                            className='center'
                            value={card.statC || ''}
                            onChange={(e) => handleStatusChange(e, card.id, 'statC')}
                        >
                            <option value="">----Välj----</option>
                            {statusValues.map((value) => (
                                <option key={value} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    </>
                )}
                {card.catD && (
                    <>
                        <h3 className='p-16 mt-64'>{card.catD}</h3>
                        <AccordionT
                            title={<h3>Instruktioner</h3>}
                            parameter={`catD1`}
                            number={card.number.toString()}
                            onExpandClick={handleExpandClick}
                            imageData={imageData}
                        />
                        <select
                            className='center'
                            value={card.statD || ''}
                            onChange={(e) => handleStatusChange(e, card.id, 'statD')}
                        >
                            <option value="">----Välj----</option>
                            {statusValues.map((value) => (
                                <option key={value} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    </>
                )}
                {card.catE && (
                    <>
                        <h3 className='p-16 mt-64'>{card.catE}</h3>
                        <AccordionT
                            title={<h3>Instruktioner</h3>}
                            parameter={`catE1`}
                            number={card.number.toString()}
                            onExpandClick={handleExpandClick}
                            imageData={imageData}
                        />
                        <select
                            className='center'
                            value={card.statE || ''}
                            onChange={(e) => handleStatusChange(e, card.id, 'statE')}
                        >
                            <option value="">----Välj----</option>
                            {statusValues.map((value) => (
                                <option key={value} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    </>
                )}

            </div>
        </>
    );
}

export default DrivingNotesComponent;
